import { AfterViewInit, Component, ViewChild } from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import { ModalBaseComponent } from 'web-common/src/app/modals/modal-factory/modal-base/modal-base.component';
import { AdminAvailableModals } from '../admin-available-modals';

@Component({
    selector: 'app-report-download-info',
    templateUrl: './report-download-notification.component.html',
    standalone: false
})
export class ReportDownloadNotificationComponent extends ModalBaseComponent<any> implements AfterViewInit {

  @ViewChild('reportDownloadInfo', { static: true }) public modalView: ModalDirective;
  ngAfterViewInit(): void {
    this.modalId = AdminAvailableModals.REPORT_DOWNLOAD_NOTIFICATION;
    this.modalView.show();
    this.modalView.onShown.subscribe(() => {
      document.getElementById('modal-close-button').focus();
    });
    this.modalView.onHidden.subscribe(() => {
      document.getElementById('downloadUsersButton').focus();
    });
  }
}
